export default __webpack_public_path__ + "static/media/barra.ba36172c.png";